import React from 'react'
import { TWHeroBlock } from '../../../TWHeroBlock/TWHeroBlock'
import { StyledHeroImage } from '../../../TWHeroBlock/TWHeroBlock.styled'
import { TWAppDownloadWidget } from '../TWAppDownloadWidget/TWAppDownloadWidget'

const HERO_IMAGE_SRC = require('../assets/tw-app-download-hero-image.webp')

export function TWAppDownloadHeroBlock() {
    return (
        <TWHeroBlock
            title={'Download the app to be the first to know when news breaks'}
            description={
                'Enjoy the very latest news and exclusive stories, live on your device.'
            }
            pageTitle={'THE WEST APP'}
            leftExtraContent={<TWAppDownloadWidget />}
            rightContent={
                <StyledHeroImage
                    src={HERO_IMAGE_SRC}
                    alt="Download The West App"
                />
            }
        />
    )
}
